"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpkIndexerApi = void 0;
const axios_1 = __importDefault(require("axios"));
class SpkIndexerApi {
    constructor(apiHost) {
        this.apiHost = apiHost;
    }
    get apiBaseUrl() {
        return `${this.apiHost}/api/v0`;
    }
    requestDocumentReindex(streamId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield axios_1.default.put(`${this.apiBaseUrl}/indexer/index/${streamId}`);
            }
            catch (err) {
                console.error(err);
                throw new Error(`Problem reindexing document with streamId ${streamId}: ${err.message}`);
            }
        });
    }
    requestDocumentFirstIndex(streamId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield axios_1.default.post(`${this.apiBaseUrl}/indexer/index/${streamId}`);
            }
            catch (err) {
                console.error(err);
                throw new Error(`Problem reindexing document with streamId ${streamId}: ${err.message}`);
            }
        });
    }
    getDocument(streamId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield axios_1.default.get(`${this.apiBaseUrl}/indexer/documents/${streamId}`);
                return res.data;
            }
            catch (err) {
                console.error(err);
                throw new Error(`Problem getting document with streamId ${streamId}, ${err.message}`);
            }
        });
    }
    getDocsForUser(userId, sort, page, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                params: {
                    page,
                    pageSize,
                    userId,
                    sort,
                },
            };
            try {
                const res = yield axios_1.default.get(`${this.apiBaseUrl}/indexer/foruser/userdocuments`, config);
                return res.data;
            }
            catch (err) {
                throw new Error(`Problem getting user docs for user ID ${userId}, ${err.message}`);
            }
        });
    }
    getDocChildren(parentId, sort, page, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                params: {
                    page,
                    pageSize,
                    parentId,
                    sort,
                },
            };
            try {
                const res = yield axios_1.default.get(`${this.apiBaseUrl}/indexer/children`, config);
                return res.data;
            }
            catch (err) {
                throw new Error(`Problem getting doc children with parent id ${parentId}: ${err.message}`);
            }
        });
    }
    getFeedDocs(page, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                params: {
                    page,
                    pageSize,
                },
            };
            try {
                const res = yield axios_1.default.get(`${this.apiBaseUrl}/indexer/feed`, config);
                return res.data;
            }
            catch (err) {
                throw new Error(`Problem fetching document feed: ${err.message}`);
            }
        });
    }
}
exports.SpkIndexerApi = SpkIndexerApi;
